import { render, staticRenderFns } from "./coopen.vue?vue&type=template&id=3a8893a0&"
import script from "./coopen.vue?vue&type=script&lang=js&"
export * from "./coopen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports